import React from "react";
import { UploadAddon } from "./addons/UploadAddons/UploadAddon";
import { IAddonRegistry } from "./addons/AddonRegistry";
import { SelectSheetAddon } from "./addons/UploadAddons/SelectSheetAddon";
import { SelectHeaderStepAddon } from "./addons/MappingAddons/SelectHeaderAddon";
import { useUploaderFlow } from "./hooks/useUploaderFlow";
import { useAddonsManager } from "./addons/providers/AddonsManagerProvider";
import { MatchColumnsAddon } from "./addons/MappingAddons/MatchColumnsAddon";
import AddonsInitializer from "./addons/AddonsInitializer";
import { useCurrentOrganisationId } from "../../../services/local/organisationContext/OrganisationContextModel";
import { EntityRelationValidationAddon } from "./addons/EntityRelationAddons/EntityRelationValidation/EntityRelationValidationAddon";
import { ValidateDataAddon } from "./addons/ValidateDataAddons/ValidateDataAddon";
import { AddonRenderer } from "./addons/AddonRenderer";
import Stepper from "./components/Stepper/Stepper";
import { steps, stepTypeToStepIndex } from "./utils/steps";
import { Step } from "./components/Step/Step";
import I18n from "../../../core/localization/I18n";
import { Hr } from "@flightpath/coreui/dist/ui/hr";

export const defaultAddonRegistry: IAddonRegistry = {
  uploadAddon: UploadAddon,
  selectSheetAddon: SelectSheetAddon,
  selectHeaderAddon: SelectHeaderStepAddon,
  matchColumnsAddon: MatchColumnsAddon,
  entityRelationValidationAddon: EntityRelationValidationAddon,
  validateDataAddon: ValidateDataAddon
};

interface UploaderFlowProps {}

export const UploaderFlow: React.FC<UploaderFlowProps> = () => {
  const {
    gridType,
    fields,
    maxRecords,
    maxFileSize,
    uploadStepHook,
    selectHeaderStepHook,
    matchColumnsStepHook,
    autoMapHeaders,
    autoMapEntityRelationValues,
    dateFormat,
    parseRaw,
    onSubmit,
    addons,
    addonRegistry
  } = useUploaderFlow();

  const { currentStep, onStepSelect } = useAddonsManager();

  const organisationId = useCurrentOrganisationId();

  return (
    <div className="container-fluid pt-3 px-0 m-0 uploader-flow">
      <div className="row p-0 m-0">
        <div className="col d-flex flex-column justify-content-between p-0">
          <Stepper className="row" activeStep={stepTypeToStepIndex(currentStep)} onClickStep={onStepSelect}>
            {steps.map(key => {
              return <Step label={I18n.t(`phrases.${key}`)} key={key} />;
            })}
          </Stepper>
          <Hr className="row my-2"></Hr>
          <div className={"row m-0"}>
            <AddonsInitializer
              params={{
                gridType,
                fields,
                maxRecords,
                maxFileSize,
                uploadStepHook,
                selectHeaderStepHook,
                matchColumnsStepHook,
                autoMapHeaders,
                autoMapEntityRelationValues,
                dateFormat,
                parseRaw,
                onSubmit,
                organisationId,
                registeredAddons: []
              }}
              addons={addons}
              addonRegistry={addonRegistry}
            />
            <AddonRenderer />
          </div>
        </div>
      </div>
    </div>
  );
};
